import { ConcreteEncodable } from "./ConcreteEncodable";

import { QuerySortImplEncoder } from "../../encoder/QuerySortImplEncoder";

import * as CubiqTS from "../../index";
import { QuerySort } from "../QuerySort";

export class QuerySortImpl extends ConcreteEncodable implements QuerySort {
  public static enType: string = "com.bcdfx.model.query.QuerySortImpl";

  /*FID=100*/
  public messageId: string;
  /*FID=550*/
  public querySortEntries: Array<CubiqTS.QuerySortEntry> | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = QuerySortImplEncoder.Instance;
    this.setEncodableType(QuerySortImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "QuerySortImpl[" +
      "messageId=" +
      this.messageId +
      "querySortEntries=" +
      this.querySortEntries +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
